module.exports = __webpack_public_path__ + "media/images/elionline/icons/da_assegnare_test_ufficiale-7bb49915192a11ef2f82fd18ec637c23.svg";